<h2 mat-dialog-title>Errors </h2>
<mat-dialog-content class="mat-typography">
    <ul>
        <li *ngFor="let error of errors">{{ error }}</li>
    </ul>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close class="btn btn-danger">Acceptar</button>
</mat-dialog-actions>